/*
店长中心/店铺中心 资金管理
 */
export default [
  //店长中心
  {
    path: '/fundManagement/rewardFundRevenueList',
    component: resolve => require(['../../views/fundManagement/rewardFundRevenueList.vue'], resolve),
    meta: {
      title: '奖励基金收益列表'
    }
  },
  {
    path: '/fundManagement/rewardFundWithdrawalManagement',
    component: resolve => require(['../../views/fundManagement/rewardFundWithdrawalManagement.vue'], resolve),
    meta: {
      title: '奖励基金提现管理'
    }
  },
  // 店铺中心
  {
    path: '/fund/rewardFundRevenueList',
    component: resolve => require(['../../views/fundManagement/rewardFundRevenueList.vue'], resolve),
    meta: {
      title: '奖励基金收益列表'
    }
  },
  {
    path: '/fund/rewardFundWithdrawalManagement',
    component: resolve => require(['../../views/fundManagement/rewardFundWithdrawalManagement.vue'], resolve),
    meta: {
      title: '奖励基金提现管理'
    }
  }
]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/fundManagement.js